import { trigger, transition, style, query, animateChild, group, animate } from '@angular/animations';

export const routeTransitionAnimations = trigger('triggerName', [
  transition('One => Two, Three => One, Two => One', [
    style({ position: 'relative' }),
    query(
      ':enter, :leave',
      [
        style({
          position: 'absolute',
          top: 0,
          right: 0,
          width: '100vw',
          height: '100vh',
        }),
      ],
      { optional: true },
    ),

    query(':enter', [style({ transform: 'translateY(100vh)', opacity: 1, offset: 0, 'z-index': 99 })], {
      optional: true,
    }),
    query(':leave', animateChild(), { optional: true }),
    group([
      query(':leave', [animate('1500ms ease-out', style({ 'z-index': 0 }))], { optional: true }),
      query(
        ':enter',
        [animate('1500ms ease-in', style({ transform: 'translateY(0vh)', opacity: 1, offset: 0, 'z-index': 99 }))],
        { optional: true, delay: 1000 },
      ),
    ]),
    query(':enter', animateChild(), { optional: true }),
  ]),
  transition('Two => Three, One => Three', [
    style({ position: 'relative' }),
    query(
      ':enter, :leave',
      [
        style({
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
        }),
      ],
      { optional: true },
    ),
    query(':leave', [style({ transform: 'translateY(0vh)', opacity: 1, offset: 0, 'z-index': 99 })], {
      optional: true,
    }),
    query(':leave', animateChild(), { optional: true }),
    group([
      query(':enter', [animate('1500ms ease-out', style({ 'z-index': 0 }))], { optional: true }),
      query(
        ':leave',
        [animate('1500ms ease-in', style({ transform: 'translateY(100vh)', opacity: 1, offset: 0, 'z-index': 99 }))],
        { optional: true },
      ),
    ]),
    query(':enter', animateChild(), { optional: true }),
  ]),
]);
